<app-form-page [config]="config"></app-form-page>
